import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { QueryKeys } from '@/constants/QueryKeys';
import { RetailerApi } from '@/utilities/api/RetailerApi';
import { SubwalletApi } from '@/utilities/api/SubwalletApi';
import { FilterDisplayContext } from "@/pages/Admin/NotificationBuilder/utils/filterFormatting";
import { agronomyProgramsOnly } from '@/utilities/RewardsProgramUtility';

export function useFilterDisplayContext (retailerId: string | undefined) {
  const { data: retailer } = useQuery(
    [QueryKeys.GET_RETAILER_BY_ID, retailerId],
    () => RetailerApi.get(retailerId!),
    { enabled: !!retailerId },
  );

  const { data: subwallets = [] } = useQuery(
    [QueryKeys.LIST_SUBWALLETS, retailerId],
    () => SubwalletApi.list({ retailerId: retailerId! }),
    { enabled: !!retailerId },
  );

  const filterDisplayContext: FilterDisplayContext = useMemo(() => {
    const rankToTierNameMap: Record<number, string> = {};
    agronomyProgramsOnly(retailer?.rewardsPrograms)[0]?.tiers?.forEach((tier) => {
      rankToTierNameMap[tier.rank] = tier.name;
    });

    const rewardsProgramIdToDatesMap: Record<string, { startDate: string; endDate: string }> = {};
    retailer?.rewardsPrograms?.forEach((program) => {
      rewardsProgramIdToDatesMap[program.id] = {
        startDate: program.startDate,
        endDate: program.endDate,
      };
    });

    const subwalletIdToNameMap: Record<string, string> = {};
    subwallets.forEach((sw) => { subwalletIdToNameMap[sw.id] = sw.name; });

    return { rankToTierNameMap, rewardsProgramIdToDatesMap, subwalletIdToNameMap };
  }, [retailer, subwallets]);

  return { filterDisplayContext, retailer, subwallets };
}
